"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APInlineButton = _interopRequireDefault(require("../APInlineButton"));
var _APInput = require("../APInput");
require("./APSearchInput.css");
var _reactI18next = require("react-i18next");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClass = 'ap-search-input';
var APSearchInput = function APSearchInput(_ref) {
  var _ref$customClass = _ref.customClass,
    customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    onCancel = _ref.onCancel,
    value = _ref.value,
    onBlur = _ref.onBlur;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('search-input-wrapper', customClass)
  }, /*#__PURE__*/_react["default"].createElement(_APInput.InnerInput, {
    type: "text",
    name: "currencySearch",
    placeholder: placeholder || t('Search'),
    customClass: bemClasses('search'),
    classModifiers: customClass,
    input: {
      value: value,
      onChange: onChange
    },
    onBlur: onBlur
  }), /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], {
    icon: "cancel",
    iconModifier: "small",
    customClass: bemClasses('search-input-cancel-icon', ["".concat(!value ? 'cancel-hidden' : '')]),
    onClick: onCancel
  }));
};
APSearchInput.propTypes = {
  placeholder: _propTypes["default"].string,
  isReduxFormInput: _propTypes["default"].bool,
  customClass: _propTypes["default"].string,
  onCancel: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};
APSearchInput.defaultProps = {
  isReduxFormInput: true
};
var _default = exports["default"] = APSearchInput;